<template>
  <div :style="styles">
    <chart :options="options" v-if="data" style="height: 100%; position: relative;"/>
    <b-card style="height: 100%" v-else>
      <align-middle style="text-align: center;">
        <i class="fa fa-spinner fa-spin fa-2x"/>
      </align-middle>
    </b-card>
  </div>
</template>

<script>
  import {Chart} from 'highcharts-vue';
  import moment from 'moment';
  import AlignMiddle from '../Sources/AlignMiddle';

  export default {
    name: 'GrowthChart',
    components: {Chart, AlignMiddle},
    props: {
      primary: Boolean,

      data: Object,
      percentage: Boolean,

      title: String,
      noTitleSuffix: Boolean,

      valueTitle: String,
      valueName: String,

      hideAggregation: Boolean,
      aggregationTitle: String,
      aggregationName: String,
    },

    computed: {
      styles() {
        return {
          height: this.primary ? '350px' : '100%',
          position: 'relative'
        };
      },

      options() {
        const {values, unit, start, end} = this.data;

        const valueTotal = values.reduce((s, r) => s + r.value, 0);
        const cumulativeTotal = values[values.length - 1].cumulative;
        const maybePercent = (value, total) => this.percentage ? 100 * value / total : value;

        var titleSuffix = this.noTitleSuffix ? '' : (() => {
          const format = ['year', 'month'].includes(unit) ? 'MMM YYYY' : 'D/MM/YY';
          const from = moment(start)
            .format(format);
          const to = moment(end)
            .format(format);
          return ` - ${from} to ${to}`;
        })();

        titleSuffix = (titleSuffix.indexOf('Invalid') > -1) ? '' : titleSuffix;

        return {
          chart: {
            zoomType: 'xy'
          },
          title: {
            text: this.title ? `${this.title}${titleSuffix}` : ''
          },
          xAxis: {
            categories: values.map(row => {
              switch (unit) {
                case 'year':
                  return row.year;
                case 'month':
                  return moment(Date.UTC(row.year, row.month - 1))
                    .format('MMM \'YY');
                case 'day':
                  return moment(Date.UTC(row.year, row.month - 1, row.day))
                    .format('DD MMM');
              }
            }),
            crosshair: true
          },

          yAxis: [{ // Primary yAxis
            title: {
              text: this.valueTitle,
            }
          }, { // Secondary yAxis
            title: {
              text: this.aggregationTitle,
            },
            opposite: true
          }].slice(0, this.hideAggregation ? 1 : 2),

          tooltip: {
            crosshairs: true,
            shared: true
          },
          series: [{
            showInLegend: !this.hideAggregation,
            name: this.valueName,
            type: 'column',
            data: values.map(row => maybePercent(row.value, valueTotal))
          }, {
            name: this.aggregationName,
            type: 'spline',
            data: values.map(row => maybePercent(row.cumulative, cumulativeTotal)),
            yAxis: 1,
            color: 'orange',
            marker: {
              enabled: false
            }
          }].slice(0, this.hideAggregation ? 1 : 2)
        };
      }
    }
  };
</script>

<style scoped>

</style>
